import React from 'react'
import { Instagram , Facebook , Twitter , MapPin, Phone,  Mail} from 'lucide-react'
import { Link } from 'react-router-dom'


const Footer = () => {
  return (
    <div className='bg-gray-900 text-gray-300'>
        <div className=' flex p-3 justify-between flex-wrap' >
        <div className='mb-2'>
            <h2 className='text-lg text-white'>Nestora</h2>
            <p>Crafting beautiful spaces with timeless furniture pieces since 2020.</p>
            <div className='flex gap-5 mt-3 '>
            <Facebook className='hover:text-white cursor-pointer'></Facebook>
            <Instagram className='hover:text-white cursor-pointer'></Instagram>
            <Twitter className='hover:text-white cursor-pointer'/>
            </div>

        </div>
        <div className='mb-2'>
            <h2 className='text-lg mb-3 text-white'>Quick Links</h2>
            <ul>
                <li className='mb-1.5 hover:text-white'><Link to="/about">About us</Link></li>
                <li className='mb-1.5 hover:text-white'><Link to="/contact">Contact</Link></li>
                <li className='mb-1.5 hover:text-white'><a href='#'>FAQ</a></li>
                <li className='mb-1.5 hover:text-white'><a href='#'>Terms & Conditions</a></li>
                <li className='mb-1.5 hover:text-white'><a href='#'>Privacy Policy</a></li>


            </ul>
            
        </div>
        <div className='mb-2'>
            <h2 className='text-lg mb-3 text-white'>Categoriess</h2>
            <ul>
                <li className='mb-1.5 hover:text-white'><a href='/mainpage'>Chairs</a></li>
                <li className='mb-1.5 hover:text-white'><a href='/mainpage'>Sofas</a></li>
                <li className='mb-1.5 hover:text-white'><a href='/mainpage'>Beds</a></li>
                <li className='mb-1.5 hover:text-white'><a href='/mainpage'>Tables</a></li>
                <li className='mb-1.5 hover:text-white'><a href='/mainpage'>Storage</a></li>
                


            </ul>
            
        </div>
        <div className='mb-2'>
            <h2 className='text-lg mb-3 text-white'>Contact US</h2>
            <ul>
                <li className='flex items-center mb-2 gap-1'><MapPin/> 477 , Design Line <br></br>Guntur , Andhra Pradesh</li>
                <li className='flex items-center mb-2 gap-1'><Phone/>+91 9876543210</li>
                <li className='flex items-center mb-2 gap-1'><Mail/>contact@nestro.com</li>


            </ul>
            
        </div>
        
    </div>
    <p className='h-[1px] bg-slate-300 ml-20 mr-20 mt-3'></p>
    <p className='text-center pt-1 pb-1'>© 2025 Nestora. All rights reserved.</p>
    </div>
  )
}

export default Footer